<template>
  <div class="teacher-class-container">
    <div class="banner">
      <div class="banner-img">
        <img src="@/assets/images/banner1.png"  alt="">
      </div>
    </div>
    <div class="content">
      <div class="left-container">
        <a href="javascript:;" class="item" :class="{active:index===navIndex}" v-for="(item,index) in navData" :key="index" @click="onSelectNav(index,item.path)">
          <span>{{item.name}}</span>
          <img src="@/assets/images/1.png" class="icon" alt="" v-show="index===navIndex">
        </a>
        <a href="javascript:;" class="item" @click="onPaper">
          <span>组卷系统</span>
          <img src="@/assets/images/1.png" class="icon" alt="" v-show="false">
        </a>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
  // import md5 from 'js-md5';
  export default {
    components: {
      
    },
    data() {
      return {
        navData:[
          {'id':1,name:'我的班级', path:'/teacher/class'},
          {'id':2,name:'班级作业', path:'/teacher/assignment'},
          {'id':3,name:'制定作业', path:'/work/knowledge'}
        ],
        navIndex:0
      }
    },
    created() {
      this.path = this.$route.path;
      this.navIndex = this.navData.findIndex(item => item.path === this.path );
    },
    updated() {
      this.path = this.$route.path;
      this.navIndex = this.navData.findIndex(item => item.path === this.path );
    },
    methods: {
      onSelectNav(i,path){
        if(this.navIndex === i){
          return false;
        }
        this.navIndex = i;
        this.$router.push(path);
      },
      onPaper(){
        this.getRequest("/wenjiaoopne/kc/user/getPaperLogin")
        .then((result) => {
          if (result.error_code != 0) {
            this.$message.error(result.message);
            return false;
          }
         window.open(`http://100zujuan.canpoint.net/user/login.aspx?user=${result.data.user}&pwd=${result.data.password}`);
        })
        .catch(() => {});
      }
    }
  }
</script>
<style scoped>
  @import '../../assets/css/teacher.css';
  .teacher-class-container .banner{
  width: 100%;
  height: 173px;
  background-image: url("../../assets/images/banner_bg.png");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}

</style>